import React from "react";
import Compensation from "../../../images/Compensation.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import backArrow from "../../../images/back-arrow.svg";
import UploadSvg from "../../../images/upload.svg";
import AttachmentTable from "../AttachmentTable";
import CustomSelect from "../../../containers/Common/CustomSelect";
import * as utilities from "../../../utilities/utils";
import { EVENT_TYPE, EVENT_TYPE_FR } from "../../../App.config";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";


const AccidentDetails = ({
  state,
  previousStep,
  onSubmit,
  props,
  handleChanges,
  download,
  removeFile,
  attachmentRef,
  addDescription,
  handleFileUpload,
  onDateChange,
  onCustomDropdownChange
}) => {

  const onDrpInputchange = () => {

  }


  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("AIR-Accident-Details.form.heading.text")}
                </span>
              </h2>
            </div>
            <div className="panel-content">
            <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="" className="mr-3">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.InjuryLocation"
                        )}

                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        className="mr-1"
                        id="sameAddresRTW"
                        type="checkbox"
                        name="sameAddresRTW"
                        value={state.sameAddresRTW.value}
                        checked={state.sameAddresRTW.value}
                        onChange={handleChanges}
                      />

                      <label>{props.context.t(
                        "AIR-Accident-Details.form.label.text.IncidentAddressRTW"
                      )}</label>
                      <div></div>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        readOnly={state.sameAddresRTW.value ? true : false}
                        className="form-control"
                        name="accidentDetailsQues1"
                        value={state.accidentDetailsQues1.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues1.ref}
                      />
                      {state.accidentDetailsQues1?.error && (
                        <span className="error">
                          {state.accidentDetailsQues1.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.whatHappen"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="accidentDetailsQues2"
                        value={state.accidentDetailsQues2.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues2.ref}
                        className="form-control"
                      />
                      {state.accidentDetailsQues2?.error && (
                        <span className="error">
                          {state.accidentDetailsQues2.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.WhatPart"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="accidentDetailsQues3"
                        value={state.accidentDetailsQues3.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues3.ref}
                        className="form-control"
                      />
                      {state.accidentDetailsQues3?.error && (
                        <span className="error">
                          {state.accidentDetailsQues3.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.LeftOrRightHandDominant"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="leftOrRightHandDominant"
                            id="leftOrRightHandDominant-Left"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Left"
                            checked={state.leftOrRightHandDominant.value === "Left"}
                          />
                          <label htmlFor="leftOrRightHandDominant-Left">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.LeftOrRightHandDominant.Left"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="leftOrRightHandDominant"
                            id="leftOrRightHandDominant-Right"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Right"
                            checked={state.leftOrRightHandDominant.value === "Right"}
                          />
                          <label htmlFor="leftOrRightHandDominant-Right">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.LeftOrRightHandDominant.Right"
                            )}
                          </label>
                        </div>
                      </div>
                      {state.LeftOrRightHandDominant?.error && (
                        <span className="error">
                          {state.LeftOrRightHandDominant.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.Conditions"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="accidentDetailsQues4"
                        value={state.accidentDetailsQues4.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues4.ref}
                        className="form-control"
                      />
                      {state.accidentDetailsQues4?.error && (
                        <span className="error">
                          {state.accidentDetailsQues4.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.EventType"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <CustomSelect
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="eventType"
                        className="search-emp-select"
                        values={state.eventType ? state.eventType.value : undefined}
                        handleChange={(selectItems, event) => {
                          onCustomDropdownChange(selectItems, event)
                        }}
                        inputValue={state.inputValue}
                        onInputChange={(value) => {
                          onDrpInputchange(value)
                        }}
                        options={utilities.prepareOptionMulDisNew(props.i18nReducerLang == "en-US" ? EVENT_TYPE : EVENT_TYPE_FR, "ID", ["Val"])}
                      />

                      {/* <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="eventType"
                        value={state.eventType.value}
                        onChange={handleChanges}
                        ref={state.eventType.ref}
                        className="form-control"
                      /> */}
                      {state.eventType?.error && (
                        <span className="error">
                          {state.eventType.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.Identification"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="identyfyDetailsForEquipmentMaterialInvolved"
                        value={state.identyfyDetailsForEquipmentMaterialInvolved.value}
                        onChange={handleChanges}
                        ref={state.identyfyDetailsForEquipmentMaterialInvolved.ref}
                        className="form-control"
                      />
                      {state.identyfyDetailsForEquipmentMaterialInvolved?.error && (
                        <span className="error">
                          {state.identyfyDetailsForEquipmentMaterialInvolved.error}
                        </span>
                      )}
                    </div>

                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.BodilyFluidHarmfulSubstanceExposure"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="bodilyFluidHarmfulSubstanceExposure"
                        value={state.bodilyFluidHarmfulSubstanceExposure.value}
                        onChange={handleChanges}
                        ref={state.bodilyFluidHarmfulSubstanceExposure.ref}
                        className="form-control"
                      />
                      {state.bodilyFluidHarmfulSubstanceExposure?.error && (
                        <span className="error">
                          {state.bodilyFluidHarmfulSubstanceExposure.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.comments"
                        )}
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="accidentDetailsQues5"
                        value={state.accidentDetailsQues5.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues5.ref}
                        className="form-control"
                      />
                      {state.accidentDetailsQues5?.error && (
                        <span className="error">
                          {state.accidentDetailsQues5.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.SafetyEquipment"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="accidentDetailsQues9"
                        value={state.accidentDetailsQues9.value}
                        onChange={handleChanges}
                        ref={state.accidentDetailsQues9.ref}
                        className="form-control"
                      />
                      {state.accidentDetailsQues9?.error && (
                        <span className="error">
                          {state.accidentDetailsQues9.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.OSHAClassification"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-hearing-loss"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Hearing Loss"
                            checked={state.classificationOSHA.value === "Hearing Loss"}
                          />
                          <label htmlFor="classificationOSHA-hearing-loss">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.HearingLoss"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-Injury"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Injury"
                            checked={state.classificationOSHA.value === "Injury"}
                          />
                          <label htmlFor="classificationOSHA-Injury">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.Injury"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-Poisoning"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Poisoning"
                            checked={state.classificationOSHA.value === "Poisoning"}
                          />
                          <label htmlFor="classificationOSHA-Poisoning">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.Poisoning"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-SkinDisorder"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Skin Disorder"
                            checked={state.classificationOSHA.value === "Skin Disorder"}
                          />
                          <label htmlFor="classificationOSHA-SkinDisorder">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.SkinDisorder"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-AllOtherIllness"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="All Other Illness"
                            checked={state.classificationOSHA.value === "All Other Illness"}
                          />
                          <label htmlFor="classificationOSHA-AllOtherIllness">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.AllOtherIllness"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="classificationOSHA"
                            id="classificationOSHA-NA"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="NA"
                            checked={state.classificationOSHA.value === "NA"}
                          />
                          <label htmlFor="classificationOSHA-NA">
                            {props.context.t(
                              "AIR-Accident-Details.form.label.text.OSHAClassification.NA"
                            )}
                          </label>
                        </div>
                      </div>
                      {state.classificationOSHA?.error && (
                        <span className="error">
                          {state.classificationOSHA.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.RelevantFacts"
                        )}
                      </label>
                      <textarea
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="relevantFacts"
                        value={state.relevantFacts.value}
                        onChange={handleChanges}
                        ref={state.relevantFacts.ref}
                        className="form-control"
                      />
                      {state.relevantFacts?.error && (
                        <span className="error">
                          {state.relevantFacts.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>


               
                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    onClick={() => onSubmit(false, false)}
                    className="btn btn-blue"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-for-later.title"
                    )}
                  </a>
                  <a
                    tabIndex="0"
                    onClick={onSubmit}
                    className="btn btn-primary margin-left-5"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-and-move-next-step.title"
                    )}
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccidentDetails;
